module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip46-a6431d3972dd9b68b4607802ea7c87e4.jpg";